import React, { useEffect } from 'react';
const SCRIPT_SRC = 'https://widgets.tradingview-widget.com/w/en/tv-economic-map.js';

/** TradingView economic map — a custom element loaded from a module script. */
export function EconomicMap() {
  useEffect(() => {
    if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return;
    const script = document.createElement('script');
    script.type = 'module';
    script.src = SCRIPT_SRC;
    document.head.appendChild(script);
  }, []);
  return <div className="h-full w-full" data-id="element-182" data-mp="8zs4mjkmhn9b">
      {React.createElement('tv-economic-map')}
    </div>;
}